import { api } from '@/api';
import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    items: [],
    types: [],
    isLoading: false,
    uploadModal: {
      isVisible: false,
    },
  },
  mutations: {
    setSvg(state, items) {
      state.items = items;
    },
    setTypes(state, types) {
      state.types = types;
    },
    addType(state, type) {
      state.types.push(type);
    },
    updateType(state, updatedType) {
      const index = state.types.findIndex((t) => t.id === updatedType.id);
      if (index !== -1) {
        state.types.splice(index, 1, updatedType);
      }
    },
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    setUploadModalVisibility(state, visibility) {
      state.uploadModal.isVisible = visibility;
    },
  },
  actions: {
    getTypesAsStrings({ state }) {
      return state.types.map((type) => type.name);
    },
    getList({ commit, state }, filters = {}) {
      commit('setLoading', true);

      const params = {};

      if (filters.type) {
        params.type = filters.type;
      }

      if (filters.tagIds && filters.tagIds.length > 0) {
        params.tag_ids = filters.tagIds.join(',');
      }

      return api.getSvgList(params).then(({ data }) => {
        commit('setSvg', data);
      }).catch((err) => {
        message.error(`Ошибка ${err.response?.status || err.message}!`);
      }).finally(() => {
        commit('setLoading', false);
      });
    },

    getTypes({ commit }) {
      return api.getSvgTypes().then(({ data }) => {
        commit('setTypes', data.data || data);
      }).catch((err) => {
        message.error(`Ошибка загрузки типов: ${err.response?.status || err.message}`);
      });
    },

    createType({ commit, dispatch }, typeData) {
      return api.createSvgType(typeData).then(({ data }) => {
        const newType = data.data || data.type || data;
        commit('addType', newType);
        return newType;
      }).catch((err) => {
        message.error(`Ошибка создания типа: ${err.response?.status || err.message}`);
        throw err;
      });
    },

    updateType({ commit }, { id, ...typeData }) {
      return api.updateSvgType(id, typeData).then(({ data }) => {
        const updatedType = data.data || data.type || data;
        commit('updateType', updatedType);
        return updatedType;
      });
    },

    create({ dispatch }, { name, file, type }) {
      const fd = new FormData();
      fd.append('name', name);
      fd.append('file', file);
      if (type) {
        fd.append('type', type);
      }

      return api.createSvg(fd).finally(() => dispatch('getList'));
    },

    updateIconType({ dispatch }, { fileName, type }) {
      return api.updateSvgIconType(fileName, type).then(() => {
        dispatch('getList');
      });
    },

    openUploadModal({ commit, dispatch }) {
      commit('setUploadModalVisibility', true);
      dispatch('getTypes');
    },

    closeUploadModal({ commit }) {
      commit('setUploadModalVisibility', false);
    },

    deleteSvgByName({ dispatch, commit }, data) {
      commit('setLoading', true);
      const directory = data.is_hidden ? 'hidden' : 'public';
      return api.deleteSvgByName(directory, data.name).finally(() => {
        dispatch('getList');
        commit('setLoading', false);
      });
    },

    async invalidateSvg() {
      return api.invalidateSvg().then((resp) => resp);
    },

    archiveSvgByName({ dispatch, commit }, name) {
      commit('setLoading', true);
      return api.archiveSvgByName(name).finally(() => {
        dispatch('getList');
        commit('setLoading', false);
      });
    },

    restoreSvgByName({ dispatch, commit }, name) {
      commit('setLoading', true);
      return api.restoreSvgByName(name).finally(() => {
        dispatch('getList');
        commit('setLoading', false);
      });
    },
  },
};
